import { Tabs, TabsProps } from "antd";
import React from "react";
import { BemHelper } from "../../utils";
import classNames from "classnames";

const bem = new BemHelper("tabs-protec");

export const TabsProtec = (props: TabsProps) => {
  return <Tabs className={classNames(bem.block())} {...props} />;
};
